import(/* webpackMode: "eager", webpackExports: ["MainHomesAndContracts"] */ "/vercel/path0/src/components/MainHomesAndContracts.tsx");
